import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Container } from 'reactstrap';
import AssessmentList from '../assessment/AssessmentsListView/AssessmentList';
import AssessmentView from '../assessment/AssessmentView/AssessmentView';
import { Helmet } from 'react-helmet';
import AssessmentInsightCreate from './AssessmentInsightCreate';
import { useStores } from '../../hooks/use-stores';
import NoItemsYet from '../../components/manager/no-items-yet';
import { FlexDiv, ThemedButton } from '@awarego-ui/components';
import LinkIfNeed from '../../components/LinkIfNeed';
import ThreatAreaView from '../assessment/AssessmentView/threatAreas/ThreatAreaView';
import RoleRoute from '../../hocs/RoleRoute';
import { USER_ROLE } from '../../utils/constants';
import { AssessmentContext, assessmentTypes } from '../assessment/assessmentContext';

export default observer(({ companyId }) => {
    const { assessmentInsightStore, brandingStore, store } = useStores();
    const {
        loadingThreatAreaDefinitions,
    } = assessmentInsightStore;
    const { supportEmail } = brandingStore;
    const {
        assessmentsUnavailable,
        assessmentsUpgradeAllowed,
        currentCompany,
    } = store;
    const assessmentParams = assessmentTypes.hraInsight;

    useEffect(() => {
        if (currentCompany)
            assessmentInsightStore.loadThreatAreaDefinitions(
                currentCompany.company_id
            );
    }, [assessmentInsightStore, currentCompany]);


    return (
        loadingThreatAreaDefinitions === false && (
            <AssessmentContext.Provider value={assessmentParams}>
                <Container className="manager-content">
                    <Helmet>
                        <title>{brandingStore.insightsHeaderTitle}</title>
                    </Helmet>
                    {assessmentsUnavailable ? (
                        <NoItemsYet
                            img={'/static/img/assessment-locked.svg'}
                            imgAlt={'insights are unavailable'}
                            title={
                                'Insights are unavailable in your current plan'
                            }
                            text={
                                'Please upgrade your subscription to access the insights.'
                            }
                            heading={'Insights'}
                            buttons={
                                assessmentsUpgradeAllowed ? (
                                    <FlexDiv gap={24}>
                                        <LinkIfNeed link={'/subscriptions/upgrade'}>
                                            <ThemedButton
                                                mode="primary"
                                                text="Upgrade now"
                                            />
                                        </LinkIfNeed>
                                    </FlexDiv>
                                ) : (
                                    <FlexDiv gap={24}>
                                        <ThemedButton
                                            mode="primary"
                                            as="a"
                                            href={`mailto:${supportEmail}`}
                                            text="Contact to upgrade"
                                        />
                                    </FlexDiv>
                                )
                            }
                        />
                    ) : (
                        <Routes>
                            <Route
                                path="edit/:id"
                                element={
                                    <RoleRoute>
                                        <AssessmentInsightCreate
                                            companyId={companyId}
                                        />
                                    </RoleRoute>
                                }
                            />
                            <Route
                                path="create/copy/:fromId"
                                element={
                                    <RoleRoute>
                                        <AssessmentInsightCreate
                                            companyId={companyId}
                                        />
                                    </RoleRoute>
                                }
                            />
                            <Route
                                path="create"
                                element={
                                    <RoleRoute>
                                        <AssessmentInsightCreate
                                            companyId={companyId}
                                        />
                                    </RoleRoute>
                                }
                            />
                            <Route
                                path={`:id/view/threatAreas/:threatAreaCode`}
                                element={<ThreatAreaView companyId={companyId}/>}
                            />
                            <Route
                                path=":id/view/*"
                                element={
                                    <RoleRoute requiredRole={USER_ROLE.VIEWER}>
                                        <AssessmentView companyId={companyId}/>
                                    </RoleRoute>
                                }
                            />
                            <Route
                                path="active"
                                element={
                                    <RoleRoute requiredRole={USER_ROLE.VIEWER}>
                                        <AssessmentList
                                            tab="active"
                                            companyId={companyId}
                                        />
                                    </RoleRoute>
                                }
                            />
                            <Route
                                path="completed"
                                element={
                                    <RoleRoute requiredRole={USER_ROLE.VIEWER}>
                                        <AssessmentList
                                            tab="completed"
                                            companyId={companyId}
                                        />
                                    </RoleRoute>
                                }
                            />
                            <Route
                                path="draft"
                                element={
                                    <RoleRoute>
                                        <AssessmentList
                                            tab="draft"
                                            companyId={companyId}
                                        />
                                    </RoleRoute>
                                }
                            />
                            <Route
                                path="*"
                                element={
                                    <RoleRoute requiredRole={USER_ROLE.VIEWER}>
                                        <AssessmentList
                                            tab="all"
                                            companyId={companyId}
                                        />
                                    </RoleRoute>
                                }
                            />
                        </Routes>
                    )}
                </Container>
            </AssessmentContext.Provider>
        )
    );
});
